import React from 'react';
import { Image } from 'react-konva';
import scribble from 'Icon/Scribble.png';

interface Props {
  loc: { x: number; y: number; h: number };
  index: number;
  iconwidth: number;
  iconheight: number;
}
const Scribble = (props: Props) => {
  const { loc, index, iconwidth, iconheight } = props;
  const drawImage = () => {
    const imageObj = new window.Image();
    imageObj.src = scribble;
    return (
      <Image
        id={`scirbble-img-component`}
        x={loc.x + index * iconwidth}
        y={loc.y + loc.h - iconheight}
        image={imageObj}
        width={iconwidth}
        height={iconheight}
        opacity={0.4}
      />
    );
  };

  return drawImage();
};

export default Scribble;
